"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderImage;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _GatsbyImage = _interopRequireDefault(require("../components/GatsbyImage"));

var _templateObject;

function renderImage(image) {
  var el = null;

  if (image.type === 'image' && image.subtype === 'svg+xml') {
    el = /*#__PURE__*/_react.default.createElement("img", {
      className: "jam-cms-svg",
      src: image.sourceUrl
    });
  } else if (image.type === 'image') {
    el = /*#__PURE__*/_react.default.createElement(_GatsbyImage.default, {
      image: image,
      objectFit: "contain",
      alt: image.alt
    });
  } else if (image.type === 'application') {
    el = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: image.icon
    }), /*#__PURE__*/_react.default.createElement("span", null, image.title));
  }

  return /*#__PURE__*/_react.default.createElement(File, null, el);
}

var File = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  .jam-cms-svg {\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  .gatsby-image-wrapper {\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  span {\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n"])));